import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiHelperFunction from "../../api";
import { FormDataType, initialStateProps } from "./interface";

// Define a type for the payload

/**
 * API calling
 *
 *
 */

export const getAdminData = createAsyncThunk(
  "admin/dashboard/",
  async (payload: any, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "admin/dashboard/", // end point
      method: "get", // method
      data: payload, // payload data
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  }
);

// GET ADMIN ORDERS ACTIVITY DATA -- NO PAYLOAD NEEDED
export const GetOrdersActivityChartData = createAsyncThunk(
  "admin/order-items-analytics/",
  async (_, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "admin/order-items-analytics/",
      method: "get",
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  }
);

export const GetAdminNotifications = createAsyncThunk(
  "get-user-notifications/",
  async (payload: { type: string, offset: number }, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: `get-user-notifications/?type=${payload?.type}&offset=${payload?.offset}&limit=10`,
      method: "get",
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  }
);

export const MarkNotifications = createAsyncThunk(
  "mark-notifications-read/",
  async (payload: { order_item_id?: number | null }, { dispatch }) => {
    const token = localStorage.getItem("user_token");

    // ✅ Build URL dynamically — only add query if order_item_id is a valid number
    const baseUrl = "mark-notifications-read/";
    const url =
      payload?.order_item_id !== null && payload?.order_item_id !== undefined
        ? `${baseUrl}?order_item_id=${payload.order_item_id}`
        : baseUrl;

    const response = await ApiHelperFunction({
      url,
      method: "post",
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    return response?.data;
  }
);

/**
 * The initial state of the auth slice.
 */
export const initialState: initialStateProps = {
  status: "idle",
  error: "string",
  FrormData: [],
  token: " string",
  dataList: [],
  compnayTypeList: [],
  incorporationDetails: [],
  data: [],
  stateList: [],
};

/**
 * The auth slice.
 */
export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    restAll: (state) => {
      state.error = "";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAdminData.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getAdminData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.dataList = action.payload?.data || [];

        // state.UserResponse = action.payload || [];
      })
      .addCase(getAdminData.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const { restAll } = adminSlice.actions;

export default adminSlice.reducer;
